import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { CONSTANTS } from "./constant";
import { useSelector } from "react-redux";
import { useProfileCTX } from "./ProfileCTX";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(false);
  const userDataString = localStorage.getItem("userData");
  const Admin = JSON.parse(userDataString);
  // const profileData = useSelector((state) => state?.user?.profileData);
  const { profileData } = useProfileCTX();
  const AdminId = Admin?.data?._id;
  const [socket, setSocket] = useState(
    io(
      // "https://iwash.updatemedaily.com?userId=661fd17862478eff96e52035&role=admin",
      `https://iwash.updatemedaily.com?userId=${Admin?.data?._id}&role=${Admin?.data?.role}`,

      {
        autoConnect: false,
      }
    )
  );
  console.log("Admin===>", Admin);
  console.log("ProfileContext", profileData);
  const connect = (userId, role) => {
    if (!socket) return;
    console.log("connecting");
    socket.open();
  };

  const disconnect = () => {
    if (!socket) return;
    console.log("disconnecting");
    socket.close();
  };

  useEffect(() => {
    if (socket) {
      connect();
      socket?.on("connect", () => {
        setIsOnline(true);
        console.log("connected");
      });

      socket?.on("disconnect", () => {
        setIsOnline(false);
        console.log("disconnected");
      });
    }
    return () => {
      disconnect();
    };
  }, [profileData]);
  console.log("isOnline", isOnline);
  return (
    <SocketContext.Provider value={{ connect, disconnect, isOnline, socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
